import { init as revenueCatInit } from '../../lib/revenueCat'
import { api } from '../../lib/stripe'
export { getSubscriptionById } from '../../lib/revenueCat'
export { findAuthenticationRequiredPayment } from './findAuthenticationRequiredPayment'
export {
  buildPreSaleBillingStatements,
  calculatePreSaleFee,
  resolvePreSaleItemPrice,
} from './preSaleBilling'
export { purchase } from './purchase'
export {
  useCompleteCartPayment,
  useCompleteChargePrepaidPoint,
  useCompleteResaleItemPayment,
  useCompleteSubscriptionPayment,
} from './useCompletePayment'

export const init = (stripeApiKey: string, revenueCatApiKey: string) => {
  api.interceptors.request.use(request => {
    request.headers.Authorization = `Bearer ${stripeApiKey}`
    return request
  })

  revenueCatInit(revenueCatApiKey)
}
